import React, { FC } from 'react'
import { RouteProps, Route } from 'react-router-dom'
import { Analytics } from 'src/utils/Analytics'
import { DEFAULT_APP_URLS, frontendURL } from 'src/network/FlockjayProvider'
import { sharedAppStateStore } from 'src/store/AppStateStore'
import { sharedDataStore } from 'src/store/DataStore'
import { observer } from 'mobx-react'
import { computed, makeObservable } from 'mobx'
import { NotFound } from 'src/pages/NotFound'

const RedirectRoute: FC<{ redirectUri: string }> = (props) => {
  Analytics.trackPage()
  const { redirectUri, ...rest } = props
  window.location.replace(redirectUri)
  return <Route {...rest} />
}

@observer
class HomeRedirectRoute extends React.Component<RouteProps> {
  constructor(props) {
    super(props)
    makeObservable(this)
  }

  @computed get authState() {
    let state = sharedDataStore.authState
    if (sharedAppStateStore.externalAcademy?.data.customHome) {
      sharedAppStateStore.navigate(sharedAppStateStore.externalAcademy?.data.customHome)
    } else if (sharedDataStore.authState === 'authorized') {
      sharedAppStateStore.navigate(sharedDataStore.getLoginHandlerPath())
    } else if (!DEFAULT_APP_URLS.includes(window.location.origin)) {
      return 'not-found'
    } else if (state === 'unauthorized' || state === 'not-found') {
      window.location.replace(`${frontendURL}/home`)
    }
    return state
  }

  render() {
    return this.authState === 'loading' ? (
      <></>
    ) : this.authState === 'not-found' ? (
      <Route {...this.props} component={NotFound} />
    ) : (
      <Route {...this.props} />
    )
  }
}

export { RedirectRoute, HomeRedirectRoute }
